import {h, Component} from 'preact'

import AsideDesignAccents from '../AsideDesignAccents'
import AsideFreeImages from '../AsideFreeImages'
import AsideUploads from '../AsideUploads'
import AsideLogos from '../AsideLogos'

import {connect} from 'react-redux'
import reduce from '../../reducers'
import * as actions from '../../actions'
import constants from '../../constants'

export default @connect(reduce, actions)
class AsideElements extends Component {
    constructor() {
        super();
    }

    viewDesignAccents () {
        this.goToView('accents')
    }

    viewUploads () {
        this.goToView('uploads')
    }

    viewLogos() {
        this.goToView('logos')
    }

    viewFreeImages () {
        this.goToView('free')
    }

    viewIllustrations () {
        this.goToView('illustrations')
    }

    viewFrames () {
        this.goToView('frames')
    }

    viewBackgrounds () {
        this.goToView('backgrounds')
    }

    viewShapes () {
        this.goToView('shapes')
    }

    goToView (view) {
        this.props.goToSubview(view)
    }

    goToRoot () {
        this.props.goToSubview('root')
    }


    render (props, state) {
        let content = null;

        switch (props.subview) {
            case 'accents':
                content = <AsideDesignAccents goToRoot={this.goToRoot.bind(this)} isPhotoSwap={true} />;
                break;
            case 'free':
                content = <AsideFreeImages goToRoot={this.goToRoot.bind(this)} isPhotoSwap={true} />;
                break;
            case 'uploads':
                content = <AsideUploads goToRoot={this.goToRoot.bind(this)} isPhotoSwap={true} />;
                break;
            case 'logos':
                content = <AsideLogos goToRoot={this.goToRoot.bind(this)} isPhotoSwap={true} />;
                break;
            default:
                content =
                    <div className="link-images">
                        <ul>
                            <li className={(props.accents && (props.accents.illustrations.length > 0 || props.accents.images.length > 0)) ? '' : 'hidden'}>
                                <a className="color" onClick={() => this.viewDesignAccents()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-design-accents" }/></svg>
                                    </span>
                                    <h6>Template Art</h6>
                                </a>
                            </li>
                            <li>
                                <a className="color" onClick={() => this.viewFreeImages()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-free-photos" }/></svg>
                                    </span>
                                    <h6>Free Photos</h6>
                                </a>
                            </li>
                            <li>
                                <a className="color" onClick={() => this.viewLogos()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-logos"}/></svg></span>
                                    <h6>
                                        My Logos
                                    </h6>
                                </a>
                            </li>
                            <li>
                                <a className="color" onClick={() => this.viewUploads()}>
                                    <span className="icon">
                                        <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-uploads" }/></svg></span>
                                    <h6>My Uploads</h6>
                                </a>
                            </li>
                        </ul>
                    </div>
        }

        return (
            <div className="swap-photo-widget" style="height: 60vh;">
                <div className="scroller no-top">
                    {content}
                </div>
            </div>
        )
    }
}
